'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('Collections', function() {
  const mixColor = function(corAtual, mix) {
    if (!corAtual) {
      return mix;
    }
    return Math.abs(mix - corAtual);
  };

  return {
    sortMapField: function(items, field, separator) {
      return items.map(function(i) {
        return i[field];
      }).sort()
        .join(separator || ', ');
    },

    mapField: function(items, field, separator) {
      return items.map(function(i) {
        return i[field];
      }).sort()
        .join(separator || ', ');
    },

    mixTwoColors: function(colorOne, colorTwo) {
      const cor = mixColor(`0x${colorOne.replace('#', '')}`, `0x${colorTwo.replace('#', '')}`).toString(16);

      return '000000'.substr(0, 6 - cor.length) + cor.toUpperCase();
    },

    mixColors: function(items, field) {
      const cor = Number(items.reduce(function(result, item) {
        return mixColor(`0x${item[field]}`, result);
      }, 0)).toString(16);

      return '000000'.substr(0, 6 - cor.length) + cor.toUpperCase();
    }
  };
});
